import { key } from './constants';
import { Nonce } from './types';

export const set = (value: Nonce) =>
  window.localStorage.setItem(key, JSON.stringify(value));
